import React, { useEffect } from 'react'
import styles from './serviceSec.module.css';
import { serviceBannerImg } from '../../../assets';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigData } from '../../slice/configSlice';
import { IMAGE_URL } from '../../helpers/api_helper';
import { useTranslation } from 'react-i18next';
import { LANG_AR } from '../../helpers/constant';

const ServiceBanner = () => {

    const { ref: titleRef, inView: titleInView, textAnimation } = useTextAnimation();
    const { ref: paraRef, inView: paraInView } = useTextAnimation();
    const [t, i18n] = useTranslation()
    const title = "WITH THE RIGHT <br /> CAPABILITIES,"
    const heading = "<span>CREATIVITY <br /> MAGNIFIES 10X</span>"

    const dispatch = useDispatch();
    const { data: configData, loading, error } = useSelector((state) => state.config);

    useEffect(() => {
        dispatch(fetchConfigData());
    }, [dispatch]);

    useEffect(() => {
        console.log('Config data : ', configData);
    }, [dispatch]);
    return (
        <div className={styles.servicenBanner}>
            <div className={styles.servicenBanner_inner}>
                <div className={`${styles._content} ${i18n.language === LANG_AR ? "arabSer" : ""} `}>
                    <div className={`${styles._lftTxt} ${i18n.language === LANG_AR ? "arabSerTxt" : ""}`}>
                        <motion.h3 ref={titleRef}
                            initial="hidden"
                            animate={titleInView ? "visible" : "hidden"}
                            custom={0}
                            variants={textAnimation}
                            dangerouslySetInnerHTML={{ __html: `${t("serviceOur")} <br /> <span>${t("servServices")}</span>` }}
                        //    </div> dangerouslySetInnerHTML={{ __html: {`${t("serviceOur")}`} <br /> <span>${t("servServices")}</span>, }}
                        >

                        </motion.h3>

                        {/* <motion.p ref={paraRef}
                            initial="hidden"
                            animate={titleInView ? "visible" : "hidden"}
                            custom={2}
                             dangerouslySetInnerHTML={{ __html: configData.whatWeDoDescription}}
                            variants={textAnimation}>
                        </motion.p> */}
                    </div>
                    <div className={styles._rgtImg}>
                        <img src={`${IMAGE_URL}/config/${configData.whatWeDoImage}`} alt="" loading='lazy' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceBanner
